module.exports = __webpack_public_path__ + "static/media/carte-guinee.7483f935.svg";